import { Grid, Stack, Typography } from "@mui/material";
import type { ListItemData } from "@entrilia/shared/components/inputs/CheckItemsList";

interface Props {
  companyBranding: ListItemData | undefined;
  action?: React.ReactElement;
}

const CompanyHeader = ({ companyBranding, action }: Props) => (
  <Stack direction="row" sx={{ pr: 1, alignItems: "center" }}>
    <Grid container sx={{ pr: 1, pl: 2, pt: 1.5, spacing: 1.5, alignItems: "center", direction: "row", width: "100%" }}>
      <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", flexGrow: 1 }}>
        <img src={companyBranding?.iconSrc} alt="" width={24} height={24} />
        <Typography variant="subtitle1">{companyBranding?.label}</Typography>
      </Stack>
      {action}
    </Grid>
  </Stack>
);

export default CompanyHeader;
